import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{staticClass:"action-close mt-2 mr-2",attrs:{"fab":"","small":"","color":"white"},on:{"click":function($event){return _vm.$emit('input', false)}}},[_c(VIcon,[_vm._v("mdi-close")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }